import React from "react";
import Option from "../../../../Models/forms/Option";
import SearchableDropdown from "../../../../components/SearchableDropdown";
import RecallCertificationStatusView from "../../../../Models/Recall/RecallCertificationStatusView";
import getRecallCertificationStatuses from "../../../../http/recall/getRecallCertificationStatuses";

interface RecallCertificationStatusDropdownProps {
  value?: Option | null;
  required?: boolean;
  onChange: (recallCategory: Option | null) => void;
  label?: string;
}

export default class RecallCertificationStatusDropdown extends React.Component<
  RecallCertificationStatusDropdownProps,
  { options: Option[] }
> {
  constructor(props: RecallCertificationStatusDropdownProps) {
    super(props);
    this.state = {
      options: [],
    };
  }

  componentDidMount() {
    this.getCertificationStatusOptions();
  }

  getCertificationStatusOptions(): void {
    getRecallCertificationStatuses()
      .then<Option[]>((response) =>
        RecallCertificationStatusDropdown.mapCertificationStatusToOptions(
          response.data
        )
      )
      .then((data) => {
        this.setState(() => ({ options: data }));
      })
      .catch((error) => console.log(error));
  }

  private static mapCertificationStatusToOptions(
    response: RecallCertificationStatusView[]
  ): Option[] {
    return response.map((element: RecallCertificationStatusView) => ({
      value: element.id.toString(),
      label: element.name,
    }));
  }

  render() {
    const { required, value, onChange, label } = this.props;
    const { options } = this.state;

    return (
      <SearchableDropdown
        required={required}
        Options={options}
        label={label ?? "Select certification status"}
        value={value}
        name="selectRecallCertificationStatus"
        onChange={(e: React.ChangeEvent<{}>, option: Option | null) =>
          onChange?.(option)
        }
      />
    );
  }
}
